import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const NotesIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M5,19h9V14h5V5H5Zm0,2a1.93,1.93,0,0,1-1.41-.59A1.93,1.93,0,0,1,3,19V5a1.93,1.93,0,0,1,.59-1.41A1.93,1.93,0,0,1,5,3H19a1.93,1.93,0,0,1,1.41.59A1.93,1.93,0,0,1,21,5V15l-6,6Zm3.4-7a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1Zm0-4a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1Z" />
    </SvgIcon>
  )
}
export default NotesIcon
